import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { adminCustomersQuery } from "@/lib/admin/customers.functions";
import { formatBRL } from "@/lib/format";

export const Route = createFileRoute("/admin/clientes")({
  component: AdminCustomersPage,
});

function AdminCustomersPage() {
  const [page, setPage] = useState(1);
  const { data, isLoading, isPlaceholderData } = useQuery({
    ...adminCustomersQuery(page),
    placeholderData: keepPreviousData,
  });

  const customers = data?.customers ?? [];

  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-eg-dark mb-6">Clientes</h1>

      {isLoading && (
        <div className="flex justify-center py-12">
          <Loader2 className="h-6 w-6 animate-spin text-eg-gold" />
        </div>
      )}

      <div className="overflow-x-auto rounded-lg border border-border bg-white">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-left text-xs uppercase text-muted-foreground">
              <th className="px-4 py-3">E-mail</th>
              <th className="px-4 py-3">Cadastro</th>
              <th className="px-4 py-3">Pedidos</th>
              <th className="px-4 py-3">Total gasto</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((customer) => (
              <tr key={customer.user_id} className="border-b border-border last:border-0">
                <td className="px-4 py-3 text-eg-dark">
                  {customer.email ?? (
                    <span className="italic text-muted-foreground">e-mail indisponível</span>
                  )}
                  {customer.is_admin && (
                    <span className="ml-2 rounded-full bg-green-100 px-2 py-0.5 text-xs font-semibold text-green-700">
                      Admin
                    </span>
                  )}
                </td>
                <td className="px-4 py-3 text-muted-foreground">
                  {new Date(customer.created_at).toLocaleDateString("pt-BR")}
                </td>
                <td className="px-4 py-3 text-muted-foreground">{customer.order_count}</td>
                <td className="px-4 py-3 text-muted-foreground">
                  {formatBRL(customer.total_spent)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!isLoading && customers.length === 0 && (
          <p className="p-6 text-center text-sm text-muted-foreground">
            Nenhum cliente cadastrado.
          </p>
        )}
      </div>

      <div className="mt-4 flex items-center justify-between">
        <button
          type="button"
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          disabled={page === 1}
          className="rounded-md border border-border px-4 py-2 text-sm font-medium text-eg-dark hover:bg-muted disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Anterior
        </button>
        <span className="text-sm text-muted-foreground">
          Página {page}
          {data?.totalUsers != null ? `, de ${data.totalUsers} clientes` : ""}
        </span>
        <button
          type="button"
          onClick={() => setPage((p) => (data?.hasNextPage ? p + 1 : p))}
          disabled={!data?.hasNextPage || isPlaceholderData}
          className="rounded-md border border-border px-4 py-2 text-sm font-medium text-eg-dark hover:bg-muted disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Próxima
        </button>
      </div>
    </div>
  );
}
